import colors from './colors';

const palette = {
  auth: {
    authStepButtons: {
      bg: colors.primary.main,
      outlineBorder: colors.gray[400],
      solidIcon: colors.gray[800]
    },
    layout: {
      formBg: colors.white,
      boxShadow: colors.blackOpacity[10],
      afterBg: colors.gray[100]
    },
    login: {
      iconBg: colors.primary[200],
      iconColor: colors.gray[600],
      text: {
        primary: colors.gray[600],
        secondary: colors.primary[200],
        error: colors.red[300]
      },
      inputBg: colors.primary[100],
      buttonIcon: colors.white,
      redirectedMessageColor: colors.gray[800],
      redirectedMessageBg: colors.secondary[175]
    },
    guestCheckout: {
      title: colors.gray[600],
      description: colors.gray[600],
      iconBg: colors.primary[200],
      iconColor: colors.gray[600],
      buttonBg: colors.primary.main,
      buttonColor: colors.white
    },
    existingAccount: {
      iconBg: colors.primary[200],
      iconColor: colors.gray[600],
      text: {
        primary: colors.gray[600],
        secondary: colors.gray[600],
        error: colors.red[300]
      },
      inputBg: colors.primary[100],
      buttonGuest: colors.secondary[800],
      buttonColor: colors.white,
      redirectedMessageColor: colors.gray[800],
      divider: colors.secondary[175]
    },
    reset: {
      contactsStep: {
        text: {
          primary: colors.gray[600],
          secondary: colors.white,
          error: colors.red[300]
        },
        button: {
          outlineBorder: colors.gray[400],
          outlineText: colors.gray[600]
        }
      },
      confirmationCodeStep: {
        text: {
          primary: colors.gray[600],
          secondary: colors.white,
          error: colors.red[300],
          link: colors.secondary[500]
        },
        btnIcon: colors.white,
        input: {
          activeBorder: colors.gray[200],
          background: colors.primary[100],
          placeholder: colors.gray[300]
        },
        codeResendColor: colors.gray[600],
        codeResendColorLink: colors.blue[300]
      },
      congratulationStep: {
        title: colors.gray[600],
        description: colors.gray[600],
        divider: colors.primary.main
      },
      restorePasswordStep: {
        text: {
          primary: colors.gray[600],
          secondary: colors.white,
          error: colors.red[300]
        },
        input: {
          iconBg: colors.primary[200],
          iconColor: colors.gray[600]
        },
        button: {
          outlineBorder: colors.gray[400],
          outlineText: colors.gray[600]
        }
      }
    },
    createAccount: {
      accountForm: {
        text: {
          primary: colors.gray[600],
          secondary: colors.white,
          error: colors.red[300]
        },
        iconColor: colors.gray[600],
        iconBg: colors.primary[200],
        dropdownBg: colors.primary[100],
        dropdownText: colors.black,
        placeholder: colors.gray[600],
        optionBorder: colors.gray[200]
      },
      referalCodeError: {
        codeColor: colors.red[500],
        bg: colors.red[100],
        subTitle: colors.gray[300],
        fieldIcon: colors.red[500],
        fieldBg: colors.white,
        iconColor: colors.white,
        buttonBg: colors.white,
        activeBttonBg: colors.red[500],
        buttonBgHover: colors.red[100],
        activeButtonHover: colors.red[700],
        buttonBorder: colors.red[500],
        buttonColor: colors.red[500],
        activeButtonColor: colors.white
      },
      confirmationPassword: {
        text: {
          primary: colors.gray[600],
          secondary: colors.white,
          error: colors.red[300]
        }
      }
    }
  },
  notFound: {
    title: colors.gray[600],
    description: colors.gray[300],
    buttonTitle: colors.gray[600],
    buttonLabel: colors.gray[300]
  },
  welcomePage: {
    bg: colors.primary[200],
    header: colors.gray[600],
    outlineBorder: colors.gray[600],
    outlineBg: colors.white
  },
  shop: {
    heading: colors.gray[550],
    description: colors.gray[300],
    subtitle: colors.gray[300],
    divider: colors.primary.main,
    icon: colors.primary.main,
    item: {
      divider: colors.primary.main,
      heading: colors.gray[450],
      text: colors.gray[450]
    },
    packages: {
      stepPackages: {
        heading: colors.gray[550],
        locationButtonBg: colors.black,
        subtitle: colors.gray[300],
        divider: colors.primary.main,
        filterBg: colors.primary[200],
        filterTextColor: colors.gray[600],
        item: {
          bgSelected: colors.secondary[100],
          buttonBgSelected: colors.secondary[500],
          buttonTextSelected: colors.white,
          buttonBg: colors.gray[100],
          buttonText: colors.secondary[500],
          iconSelected: colors.white,
          icon: colors.secondary[500],
          description: colors.black,
          subPackageDivider: colors.gray[300],
          dividerSelected: colors.gray[150],
          divider: colors.gray[125]
        },
        subPackages: {
          counterButtonBg: colors.white,
          buttonInsideBg: colors.white,
          buttonInsideBgHover: colors.white,
          buttonBg: colors.gray[100],
          buttonBgHover: colors.gray[100],
          price: colors.black,
          priceMd: colors.secondary[500],
          discount: colors.red[700],
          priceStrikethrough: colors.black,
          priceStrikethroughLine: colors.black,
          discountText: colors.black,
          discountTextDesktop: colors.gray[275],
          tax: colors.black,
          description: colors.black,
          dividerInside: colors.gray[300],
          divider: colors.gray[125],
          showBtn: colors.primary.main
        }
      },
      stepCartDetails: {
        heading: colors.gray[550],
        signInBg: colors.gray[100],
        signInText: colors.gray[300],
        signInButton: {
          border: colors.secondary[500]
        },
        loaderBg: colors.blackOpacity[10],
        list: {
          divider: colors.blue[400],
          packageText: colors.gray[450],
          amountText: colors.gray[450],
          qtyText: colors.gray[450],
          totalText: colors.gray[450],
          taxText: colors.black,
          subtotalText: colors.black,
          innerDivider: colors.gray[200],
          item: {
            divider: colors.gray[200],
            text: colors.black,
            discount: colors.red[400],
            amountDivider: colors.secondary[500],
            amountLabel: colors.gray[450],
            amount: colors.black,
            totalLabel: colors.gray[450],
            total: colors.black
          }
        }
      },
      stepPayment: {
        heading: colors.gray[600],
        text: colors.gray[600],
        divider: colors.primary.main,
        overlayBg: colors.secondaryOpacity[90],
        overlayTextColor: colors.white
      },
      stepFinal: {
        heading: colors.gray[600],
        text: colors.gray[600],
        divider: colors.primary.main,
        overlayBg: colors.secondaryOpacity[90],
        overlayTextColor: colors.white
      },
      stepHighlighter: {
        activeLabelBg: colors.primary.main,
        activeLabelColor: colors.white,
        resetButton: colors.gray[300],
        divider: colors.gray[350],
        selectedLocationLabel: colors.gray[450],
        selectedLocationName: colors.black
      }
    },
    giftCards: {
      title: colors.gray[600],
      description: colors.gray[600],
      divider: colors.primary.main,
      error: colors.red[500],
      progressBar: {
        background: colors.gray[600],
        completeColor: colors.primary.main,
        incompleteColor: colors.gray[250],
        activeColor: colors.white,
        activeTextColor: colors.white,
        inactiveTextColor: colors.gray[250]
      },
      list: {
        headerBg: colors.primary[100],
        headerColor: colors.gray[550],
        toggleButtonColor: colors.secondary[500],
        item: {
          boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.16)',
          selectedBorderColor: colors.black,
          unselectedBorderColor: 'transparent',
          buttonBg: colors.white,
          buttonActiveBg: colors.gray[800],
          buttonActiveBorderColor: colors.gray[800],
          buttonActiveColor: colors.white
        }
      },
      sidebar: {
        cardDetailsColor: colors.gray[600],
        cardBoxShadow: '0px 2px 3px rgba(0, 0, 0, 0.16)',
        amountLabelColor: colors.gray[300],
        amountValueColor: colors.gray[600],
        mobileBackground: colors.secondary[500],
        mobileTextColor: colors.white
      },
      stepSelectAmount: {
        title: colors.gray[600],
        promoBannerBg: colors.secondary[500],
        promoBannerText: colors.white,
        divider: colors.primary.main,
        subtitle: colors.gray[600],
        optionBg: colors.gray[100],
        optionSelectedBg: colors.secondary[500],
        optionText: colors.gray[600],
        optionSelectedText: colors.white,
        orEnterAmountText: colors.gray[600],
        inputBorder: colors.gray[260],
        inputBg: colors.gray[100],
        inputBgSelected: colors.secondary.main,
        inputText: colors.gray[600],
        inputTextSelected: colors.white,
        errorText: colors.red[500]
      },
      stepCreateAccount: {
        title: colors.gray[600],
        description: colors.gray[600],
        divider: colors.primary.main,
        emailBoxBg: colors.secondary[100],
        emailBoxColor: colors.gray[300]
      },
      stepDetails: {
        title: colors.gray[600],
        description: colors.gray[600],
        divider: colors.primary.main,
        checkboxBg: colors.primary[100],
        checkboxText: colors.gray[600],
        recipientFormTitle: colors.gray[600],
        errorText: colors.red[500],
        checkForm: {
          bg: colors.gray[100],
          bgSelected: colors.primary[300],
          svg: colors.gray[100],
          svgSelected: colors.primary[300],
          text: colors.gray[375],
          textSelected: colors.gray[800],
          email: colors.gray[375],
          saveEmail: colors.gray[375],
          selectFieldColor: colors.gray[300],
          selectFieldBorderColor: colors.primary[200],
          selectFieldBg: colors.primary[100]
        },
        recipient: {
          background: colors.primary[100],
          labelColor: colors.gray[375],
          fieldBackground: colors.white
        }
      },
      stepPaymentDetails: {
        headingColor: colors.gray[600],
        dividerColor: colors.primary.main
      },
      stepCartDetails: {
        headingColor: colors.gray[600],
        dividerColor: colors.primary.main,
        errorMsgColor: colors.red[500],
        sampleModal: {
          overlayBg: 'rgba(134, 101, 122, 0.9)',
          boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.16)'
        },
        list: {
          headerTextColor: colors.gray[500],
          dividerColor: colors.blue[400],
          taxBorderColor: colors.gray[150],
          taxLabelColor: colors.black,
          taxValueColor: colors.black,
          subtotalBorderColor: colors.gray[150],
          subtotalLabelColor: colors.black,
          subtotalValueColor: colors.black,
          item: {
            borderColor: colors.gray[150],
            imageBoxShadow: '0px 2px 3px rgba(0, 0, 0, 0.16)',
            buttonTextColor: colors.gray[800],
            dividerColor: colors.secondaryOpacity[30],
            labelColor: colors.gray[300],
            textColor: colors.gray[600],
            amountTextColor: colors.black,
            totalTextColor: colors.black,
            popupBg: colors.whiteOpacity[80],
            popupTextColor: colors.gray[600],
            buttonBoxShadow: '0px 2px 3px rgba(0, 0, 0, 0.16)'
          }
        }
      },
      stepSuccess: {
        headingColor: colors.gray[800],
        subtitleColor: colors.gray[450],
        emailLinkColor: colors.gray[450],
        downloadTextColor: colors.gray[450],
        dividerColor: colors.primary.main
      }
    },
    products: {
      listStep: {
        filterSidebar: {
          reviewStepActiveBg: colors.gray[600],
          reviewStepInactiveBg: colors.gray[115],
          reviewStepActiveText: colors.white,
          reviewStepInactiveText: colors.gray[600],
          activeBg: colors.secondary[500],
          inactiveBg: colors.gray[100],
          activeText: colors.white,
          inactiveText: colors.gray[800],
          defaultIconColor: colors.secondary[400],
          imageBg: colors.white,
          emptyImageBg: colors.primary[200],
          subTitleFilterBg: colors.gray[115],
          subTitleFilterColor: colors.gray[800],
          borderRight: colors.secondary[500],
          collapseButtonBackground: colors.secondary[500],
          collapseButtonTextColor: colors.white,
          collapseButtonIconColor: colors.white
        },
        listContainer: {
          containerBg: colors.gray[100],
          filterView: {
            breadcrumbText: colors.gray[800],
            iconActiveBg: colors.primary.main,
            iconActiveColor: colors.white,
            iconInactiveColor: colors.gray[200],
            textColor: colors.gray[800]
          },
          container: {
            activeIconColor: colors.primary.main,
            defaultIconColor: colors.secondary[200],
            emptyImageBg: colors.primary[200],
            productBg: colors.gray[50],
            itemNameColor: colors.gray[550],
            itemSubtitle: colors.gray[550],
            itemSizeColor: colors.gray[550],
            itemDescColor: colors.gray[550],
            itemCategoryColor: colors.gray[250],
            mainPriceColor: colors.gray[550],
            discountPrice: colors.gray[250],
            heartIconColor: colors.primary.main,
            counterBorder: colors.secondary[200],
            closeButtonBackground: colors.white,
            closeButtonColor: colors.black,
            imageBackground: colors.white,
            zoomIconColor: colors.gray[300]
          }
        }
      }
    },
    cart: {
      title: colors.gray[550],
      modal: {
        overlayBackground: 'rgba(0,0,0, 0.65)',
        dividerColor: colors.primary.main,
        titleColor: colors.gray[800],
        subTitleColor: colors.gray[400],
        descriptionColor: colors.gray[800],
        backBtnColor: colors.gray[300],
        loaderBg: 'rgba(0,0,0, 0.8)',
        loaderColor: colors.white
      },
      detailsStep: {
        divider: colors.blue[400],
        packageText: colors.gray[450],
        amountText: colors.gray[450],
        itemBg: colors.white,
        counterBorder: colors.secondary[200],
        defaultIconColor: colors.secondary[200],
        emptyImageBg: colors.primary[200],
        qtyText: colors.gray[450],
        totalText: colors.gray[450],
        textColor: colors.black,
        amountDivider: colors.secondary[500],
        amountLabel: colors.gray[450],
        amount: colors.black,
        taxText: colors.black,
        subtotalText: colors.black,
        innerDivider: colors.gray[200],
        footerSmallText: colors.gray[250],
        discountPriceColor: colors.gray[375],
        promo: {
          bg: colors.gray[100],
          closeIcon: colors.gray[800],
          dollar: colors.gray[800],
          titleColor: colors.gray[800],
          code: colors.gray[800],
          sum: colors.red[700]
        }
      },
      shippingStep: {
        methodBg: colors.gray[100],
        textColor: colors.gray[800],
        bg: colors.white,
        activeBg: colors.gray[800],
        activeBorder: colors.gray[800],
        activeColor: colors.white,
        iconColor: colors.primary.main
      },
      accordion: {
        bg: colors.primary[200],
        itemBg: colors.gray[100],
        sumColor: colors.black,
        emptyImageBg: colors.primary[200],
        defaultIconColor: colors.secondary[200],
        textColor: colors.black,
        qtyColor: colors.gray[450],
        amount: colors.black,
        discountPriceColor: colors.gray[375]
      }
    },
    memberships: {
      heading: colors.gray[550],
      subtitle: colors.gray[300],
      divider: colors.primary.main,
      priceMd: colors.secondary[500],
      buttonBg: colors.gray[100],
      buttonBgHover: colors.gray[100],
      description: colors.black,
      dividerInside: colors.gray[300],
      showBtn: colors.gray[300],
      overlayBg: colors.secondaryOpacity[90],
      overlayTextColor: colors.white,
      signInBg: colors.gray[100],
      signInText: colors.gray[300],
      valuedMember: colors.gray[300],
      signInButton: {
        border: colors.secondary.main
      },
      reviewStepBackground: colors.gray[100],
      reviewStepTextColor: colors.gray[800],
      iconColor: colors.gray[800]
    }
  },
  booking: {
    stepService: {
      titleColor: colors.gray[550],
      descriptionColor: colors.gray[300],
      dividerColor: colors.primary.main,
      helperTextColor: colors.secondary[600],
      loaderBg: colors.blackOpacity[10],
      addonList: {
        headerBg: colors.secondary[500],
        headerTextColor: colors.white
      },
      providerList: {
        headerBg: colors.secondary[500],
        providerItem: {
          bg: colors.gray[100],
          borderColor: colors.secondary[500],
          iconFill: colors.secondary[400],
          descriptionColor: colors.gray[300]
        },
        providerHeader: {
          textColor: colors.white,
          closeIconFill: colors.white
        }
      },
      serviceList: {
        placeholderTextColor: colors.red[300],
        reviewTabBorderColor: colors.gray[600],
        defaultBorderColor: colors.secondary[500],
        infoModal: {
          overlayBackground: 'rgba(134, 101, 122, 0.9)',
          closeButtonBackground: colors.gray[300],
          closeButtonColor: colors.black,
          bannerBorderColor: colors.gray[300],
          activeButtonBackground: colors.gray[300]
        },
        serviceItem: {
          background: colors.gray[100],
          checkedIconColor: colors.secondary[500],
          uncheckedBorderColor: colors.secondary[500],
          textColor: colors.secondary[500],
          iconColor: colors.secondary[500],
          hoverTextColor: colors.secondary[800],
          hoverIconColor: colors.secondary[800],
          iconFill: colors.secondary[400],
          dividerColor: colors.gray[225]
        },
        serviceItemAccordion: {
          openBackground: colors.secondary[400],
          closedBackground: colors.gray[115],
          openTextColor: colors.white,
          closedTextColor: colors.secondary[500],
          openChevronColor: colors.white,
          closedChevronColor: colors.secondary[500],
          serviceBackground: colors.gray[100],
          dividerColor: colors.gray[350]
        }
      },
      mobileStepper: {
        reviewStepBackground: colors.gray[115],
        activeBackground: colors.secondary[500],
        inactiveBackground: colors.gray[100],
        activeTextColor: colors.white,
        inactiveTextColor: colors.gray[800],
        activeIconColor: colors.white,
        dividerColor: colors.secondary[500],
        collapseButtonBackground: colors.secondary[500],
        collapseButtonTextColor: colors.white,
        collapseButtonIconColor: colors.white
      },
      stepper: {
        reviewStepActiveBg: colors.gray[600],
        reviewStepActiveText: colors.white,
        activeBg: colors.secondary[500],
        inactiveBg: colors.gray[100],
        activeText: colors.white,
        inactiveText: colors.gray[800]
      }
    },
    stepTime: {
      headingColor: colors.gray[550],
      descriptionColor: colors.gray[300],
      searchAgainButtonColor: colors.primary.main,
      subtitleColor: colors.gray[300],
      phoneLinkColor: colors.secondary.main,
      dividerColor: colors.primary.main,
      advancedSearch: {
        helperTextColor: colors.gray[600],
        daysLabelColor: colors.gray[375],
        dayActiveBg: colors.primary.main,
        dayInactiveBg: colors.white,
        dayTextColor: colors.gray[800],
        dayTextActiveColor: colors.gray[800]
      },
      apptData: {
        backgroundColor: colors.primary[100],
        dividerColor: colors.primary[300],
        noOpeningsTextColor: colors.red[300],
        list: {
          titleBackgroundColor: colors.primary.main,
          titleTextColor: colors.gray[800],
          item: {
            background: colors.white,
            hoverBorderColor: colors.primary.main,
            timeTextColor: colors.gray[800],
            endTimeTextColor: colors.gray[300],
            multipleProvidersBg: colors.secondary[200],
            multipleProvidersIconColor: colors.gray[100],
            providerNameTextColor: colors.gray[800],
            chevronIconColor: colors.gray[300]
          }
        }
      },
      apptDetailsList: {
        background: colors.primary[100],
        estimatedTotalLabelColor: colors.gray[300],
        estimatedTotalColor: colors.gray[800],
        detailsItem: {
          background: colors.white,
          serviceNameTextColor: colors.gray[800],
          providerIconColor: colors.secondary[400],
          providerNameTextColor: colors.secondary[800],
          providerDescriptionTextColor: colors.secondary[800],
          itemPriceTextColor: colors.gray[800],
          itemDurationTextColor: colors.gray[350],
          addonItem: {
            background: colors.white,
            addonNameTextColor: colors.gray[800],
            providerIconColor: colors.secondary[400],
            providerNameTextColor: colors.secondary[800],
            providerDescriptionTextColor: colors.secondary[800],
            addonPriceTextColor: colors.gray[800],
            addonDurationTextColor: colors.gray[350]
          }
        }
      },
      boxTabs: {
        tabBackground: colors.primary[200],
        tabTextColor: colors.gray[800],
        selectedTabBackground: colors.primary[300],
        selectedTabTextColor: colors.gray[800],
        tabPanelBorderColor: colors.primary[300],
        tabPanelBackground: colors.primary[100]
      },
      calendarSearch: {
        buttonTextColor: colors.gray[600]
      }
    },
    stepRecommended: {
      headingColor: colors.gray[550],
      descriptionColor: colors.gray[300],
      dividerColor: colors.primary.main,
      list: {
        background: colors.gray[100],
        item: {
          imageBg: colors.white,
          emptyImageBg: colors.primary[200],
          defaultIconColor: colors.secondary[200],
          titleColor: colors.gray[800],
          subTitleColor: colors.black,
          descriptionColor: colors.secondary[800],
          priceColor: colors.gray[800],
          discountPriceColor: colors.gray[375]
        }
      }
    },
    stepReview: {
      headingColor: colors.gray[550],
      descriptionColor: colors.gray[300],
      dividerColor: colors.primary.main,
      mobileDividerColor: colors.gray[225],
      assistanceTextColor: colors.gray[300],
      phoneLinkColor: colors.secondary.main,
      errorTextColor: colors.red[500],
      requiredDdescription: {
        title: colors.red[600],
        subTitle: colors.gray[800],
        boxBg: colors.primary[100],
        description: colors.gray[800]
      },
      checkboxRules: {
        errorBackground: colors.redOpacity[5],
        errorBorder: colors.red[900],
        labelColor: colors.gray[800],
        textColor: colors.gray[800]
      },
      commentsBlock: {
        background: colors.primary[100],
        labelColor: colors.gray[800],
        textareaBackground: colors.white,
        focusBorderColor: colors.primary.main
      },
      promo: {
        background: colors.secondary[175],
        textColor: colors.gray[600],
        textLightColor: colors.gray[425],
        inputColor: colors.gray[800],
        placeholderColor: colors.gray[225]
      },
      reservationList: {
        background: colors.gray[100],
        textColor: colors.gray[800],
        iconColor: colors.gray[800],
        secondaerBackground: colors.primary[200],
        discountItem: {
          background: colors.gray[100],
          closeIconFill: colors.gray[350],
          discountTextColor: colors.gray[800],
          amountColor: colors.red[700]
        },
        reservationItem: {
          background: colors.gray[100],
          serviceNameColor: colors.gray[800],
          providerNameColor: colors.black,
          providerDescriptionColor: colors.secondary[800],
          iconFill: colors.secondary[400],
          discountPriceColor: colors.secondary[500],
          priceColor: colors.gray[800],
          memberSaveColor: colors.gray[300],
          durationColor: colors.gray[350],
          dividerColor: colors.secondary[175]
        }
      }
    },
    stepSuccess: {
      headingColor: colors.gray[550],
      descriptionColor: colors.gray[300],
      dividerColor: colors.primary.main,
      headerDividerColor: colors.secondary[175],
      commentIconColor: colors.primary.main,
      commentTextColor: colors.gray[800],
      headerDetails: {
        headerBg: colors.secondary[500],
        headerText: colors.white,
        bodyBg: colors.secondary[175],
        location: colors.gray[800],
        address: colors.gray[800],
        iconColor: colors.primary.main,
        price: colors.gray[800],
        bookingText: colors.gray[800]
      },
      reviewList: {
        background: colors.gray[100],
        headerBackground: colors.secondary[500],
        headerTextColor: colors.white,
        reviewItem: {
          serviceNameColor: colors.gray[800],
          providerNameColor: colors.black,
          providerDescriptionColor: colors.secondary[800],
          iconFill: colors.secondary[400],
          discountColor: colors.secondary[500],
          priceColor: colors.gray[800],
          memberSaveColor: colors.gray[300],
          durationColor: colors.gray[350],
          dividerColor: colors.secondary[175]
        }
      },
      productList: {
        background: colors.gray[100],
        headerBackground: colors.secondary[500],
        headerTextColor: colors.white,
        borderTopColor: colors.secondary[175],
        productItem: {
          imageBg: colors.white,
          emptyImageBg: colors.white,
          defaultIconColor: colors.secondary[400],
          serviceNameColor: colors.gray[800],
          providerDescriptionColor: colors.black,
          discountColor: colors.secondary[500],
          priceColor: colors.gray[800],
          qtyColor: colors.gray[800],
          memberSaveColor: colors.gray[300],
          dividerColor: colors.secondary[175]
        }
      }
    },

    loader: {
      textColor: colors.red[300]
    }
  },

  dashboard: {
    formsTable: {
      sectionHeaderBackground: colors.primary[200],
      pastFormsHeader: colors.gray[800],
      requiredFormsHeader: colors.gray[800],
      headerBackground: colors.primary[100],
      borderBottom: colors.gray[125],
      formLabel: colors.gray[400],
      contentBackground: colors.primary[100],
      formName: colors.secondary[800],
      dueDate: colors.secondary[800],
      chevronIcon: colors.gray[800]
    },
    recentProductList: {
      primaryBg: colors.primary[100],
      secondaryBg: colors.primary[200],
      headerText: colors.gray[800],
      borderBottom: colors.gray[125],
      labelText: colors.gray[400],
      recentProductItem: {
        borderBottom: colors.gray[125],
        dateColor: colors.gray[550],
        nameColor: colors.gray[550],
        brandColor: colors.gray[300],
        priceColor: colors.gray[550],
        iconColor: colors.gray[500],
        chevronColor: colors.gray[800]
      }
    },
    dottedMenuButton: {
      borderBoxColor: colors.primary[200],
      background: colors.primary[200],
      cancelBorder: colors.primary[200],
      labelColor: colors.gray[800],
      iconColor: colors.gray[800]
    },
    upcomingAppts: {
      serviceTextColor: colors.gray[325],
      cancelButtonColor: colors.gray[800],
      chevronIconColor: colors.gray[800],
      bookButtonColor: colors.gray[800],
      titleColor: colors.gray[800],
      headerBg: colors.primary[200],
      wrapperBg: colors.primary[100],
      separatorColor: colors.gray[125]
    },

    account: {
      addresses: {
        headingColor: colors.gray[600],
        form: {
          background: colors.primary[100],
          checkboxLabelColor: colors.gray[500]
        },
        list: {
          contentLoaderBg: colors.primary[100],
          loaderBg: colors.blackOpacity[10],
          errorTextColor: colors.red[300],
          item: {
            bg: colors.primary[100],
            primaryBorderColor: colors.primary[200],
            closeIconFill: colors.gray[250],
            primaryCloseIconFill: colors.gray[800],
            nameTextColor: colors.gray[800],
            addressTextColor: colors.gray[800],
            countryTextColor: colors.gray[800],
            primaryTextColor: colors.white,
            primaryBgColor: colors.secondary.main,
            chevronRightFill: colors.gray[800]
          }
        }
      },
      creditCards: {
        headingColor: colors.gray[600],
        textColor: colors.gray[600],
        list: {
          emptyBg: colors.primary[100],
          emptyTextColor: colors.gray[225],
          item: {
            background: colors.primary[100],
            borderColor: colors.primary[200],
            activeBg: colors.primary.main,
            closeIcon: colors.gray[300],
            cardNumber: colors.gray[500],
            owner: colors.gray[800],
            primaryTextColor: colors.white,
            primaryBgColor: colors.secondary.main,
            divider: colors.secondary[500],
            defaultCardText: colors.gray[800],
            chevron: colors.gray[800]
          },
          purchaseItem: {
            bgColor: colors.primary[100],
            closeIconColor: colors.gray[300],
            cardNumberColor: colors.gray[500],
            ownerColor: colors.gray[800],
            purchaseTextColor: colors.gray[800],
            billingTextColor: colors.gray[800],
            chevronColor: colors.gray[800],
            greyColor: colors.gray[250],
            primaryColor: colors.primary.main
          }
        },
        updateForm: {
          bgColor: colors.primary[100],
          cardNumberColor: colors.gray[500],
          checkboxTextColor: colors.gray[800],
          dividerColor: colors.primary.main,
          borderColor: colors.primary.main,
          labelColor: colors.gray[375],
          textColor: colors.gray[800]
        }
      },
      preferences: {
        headingColor: colors.gray[600],
        textColor: colors.gray[600],
        itemTextColor: colors.gray[800],
        itemHeader: {
          headerBg: colors.primary[200],
          iconColor: colors.primary.main,
          titleColor: colors.gray[800],
          descriptionColor: colors.gray[800],
          contentBg: colors.primary[100]
        },
        variantCheckbox: {
          boxLabelColor: colors.primary.main,
          checkedBorderColor: colors.primary.main,
          uncheckedBorderColor: colors.gray[350],
          dividerColor: colors.primary.main
        },
        variantDropdown: {
          labelColor: colors.primary.main,
          controlColor: colors.gray[600],
          borderBottomColor: colors.gray[350],
          optionColor: colors.gray[600],
          indicatorColor: colors.gray[600]
        },
        variantList: {
          labelColor: colors.primary.main,
          buttonColor: colors.gray[600],
          dividerColor: colors.primary.main
        }
      },
      profile: {
        reviewProfile: {
          backgroundColor: colors.primary[100],
          dividerColor: colors.primary.main,
          buttonTextColor: colors.gray[600],
          iconColor: colors.gray[800]
        },
        updatePassword: {
          backgroundColor: colors.primary[100]
        },
        updateProfile: {
          backgroundColor: colors.primary[100],
          iconBg: colors.primary[200]
        }
      }
    },

    memberships: {
      title: colors.gray[600],
      descriptionColor: colors.gray[300],
      headingColor: colors.gray[600],
      joinBtn: {
        bgColor: colors.secondary.main,
        labelColor: colors.white
      },
      joinCard: {
        background: colors.primary[100],
        heading: colors.gray[800]
      },
      mshpsList: {
        containerBg: colors.primary[100],
        headerBg: colors.primary[200],
        headerTextColor: colors.gray[800],
        subHeaderTextColor: colors.gray[400],
        borderBottomColor: colors.gray[125],
        noItemsTextColor: colors.gray[225],
        mshpsItem: {
          mainColor: colors.gray[550],
          subColor: colors.gray[300],
          dividerColor: colors.gray[125],
          chevron: colors.gray[800]
        }
      },
      mshpsDetails: {
        infoBg: colors.primary[100],
        infoBorder: colors.primary[200],
        infoBoxText: colors.gray[400],
        errorBg: colors.red[200],
        errorTextColor: colors.white,
        freezeBg: colors.blue.main,
        freezeTextColor: colors.white,
        detailsBg: colors.primary[100],
        subHeaderTextColor: colors.secondary[800],
        descColor: colors.gray[400],
        dividerColor: colors.gray[125],
        payBtnBg: colors.black,
        payBtnColor: colors.white,
        creditCard: {
          background: colors.primary[100],
          cardNumber: colors.gray[500],
          divider: colors.secondary[500],
          primaryBgColor: colors.secondary.main,
          primaryTextColor: colors.white
        }
      },
      modal: {
        overlayBackground: 'rgba(0,0,0, 0.65)',
        dividerColor: colors.primary.main,
        titleColor: colors.gray[800],
        subTitleColor: colors.gray[400],
        descriptionColor: colors.gray[800],
        backBtnColor: colors.gray[300],
        loaderBg: 'rgba(0,0,0, 0.8)',
        loaderColor: colors.white
      },
      payment: {
        boxBg: colors.primary[100],
        inputBorder: colors.gray[260],
        inputBg: colors.gray[100],
        inputBgSelected: colors.white,
        inputText: colors.gray[600],
        error: colors.red[300],
        overlayBg: colors.secondaryOpacity[90],
        overlayTextColor: colors.white
      }
    },
    referFriend: {
      title: colors.gray[600],
      infoBlock: {
        bg: colors.primary[100],
        title: colors.gray[600],
        text: colors.gray[600],
        subTitle: colors.gray[275],
        referalColor: colors.gray[600],
        iconColor: colors.gray[275]
      },
      detailsBlock: {
        headingBg: colors.primary.main,
        headingColor: colors.white,
        bg: colors.primary[100],
        labelColor: colors.gray[600],
        bodyColor: colors.gray[400],
        borderInput: colors.gray[200]
      }
    },
    appointments: {
      title: colors.gray[600],
      apptList: {
        background: colors.primary[100],
        headerBackground: colors.primary[200],
        headerText: colors.gray[800],
        emptyMessage: colors.gray[200],
        apptItem: {
          date: colors.gray[800],
          time: colors.gray[800],
          serviceName: colors.gray[800],
          providerName: colors.gray[325],
          divider: colors.gray[125],
          chevron: colors.gray[800]
        }
      },
      upcomingApptList: {
        background: colors.primary[100],
        headerBackground: colors.primary[200],
        headerText: colors.gray[800],
        emptyMessage: colors.gray[200],
        upcomingApptItem: {
          date: colors.gray[800],
          time: colors.gray[800],
          serviceName: colors.gray[800],
          providerName: colors.gray[325],
          divider: colors.gray[125],
          chevron: colors.gray[800],
          moveButton: colors.secondary[800],
          cancelButton: colors.secondary[800]
        }
      },
      recent: {
        title: colors.gray[600],
        divider: colors.gray[230],
        commentDivider: colors.primary.main,
        commentIcon: colors.primary.main,
        comments: colors.gray[800],
        buttonBg: colors.gray[800],
        overlayBg: colors.blackOpacity[10],
        headerBackground: colors.primary[250],
        contentBackground: colors.primary[100],
        date: colors.gray[800],
        buttonText: colors.gray[800],
        location: colors.gray[800],
        iconLocationColor: colors.primary.main,
        address: colors.gray[800],
        amount: colors.gray[800],
        serviceBackground: colors.primary[100],
        repeatButtonBg: colors.gray[800],
        receiptButtonText: colors.gray[800],
        receiptButtonBg: colors.secondary[175],
        repeatMobileButtonText: colors.gray[800],
        repeatMobileButtonBg: colors.secondary[175],
        serviceItem: {
          name: colors.gray[800],
          provider: colors.black,
          amountLabel: colors.gray[375],
          amount: colors.gray[800],
          duration: colors.gray[800],
          time: colors.gray[350],
          iconFill: colors.secondary[400],
          divider: colors.gray[230]
        }
      },
      upcoming: {
        overlayBg: colors.blackOpacity[10],
        title: colors.gray[600],
        headerBackground: colors.secondary[500],
        contentBackground: colors.gray[100],
        date: colors.white,
        divider: colors.whiteOpacity[17],
        buttonText: colors.white,
        location: colors.gray[800],
        iconLocationColor: colors.primary.main,
        address: colors.gray[800],
        amount: colors.gray[800],
        serviceBackground: colors.gray[100],
        commentDivider: colors.primary.main,
        commentIcon: colors.primary.main,
        commentText: colors.gray[800],
        repeatButtonBg: colors.gray[800],
        moveButtonText: colors.gray[800],
        moveButtonBg: colors.secondary[175],
        cancelButtonText: colors.gray[800],
        cancelButtonBg: colors.secondary[175],
        serviceItem: {
          serviceName: colors.gray[800],
          providerName: colors.black,
          amountLabel: colors.gray[375],
          amountValue: colors.gray[800],
          duration: colors.gray[800],
          time: colors.gray[350],
          iconFill: colors.secondary[400],
          divider: colors.gray[230]
        }
      }
    },

    forms: {
      formPage: {
        headerBg: colors.secondary[500],
        headerText: colors.white,
        signature: {
          containerBg: colors.gray[100],
          instructionTextColor: colors.blue[200],
          penColor: colors.black,
          textColor: colors.black,
          background: colors.white
        }
      }
    },

    gCards: {
      containerBg: colors.gray[100],
      headingColor: colors.gray[600],
      formBg: colors.primary[100],
      formLabel: colors.gray[500],
      cardList: {
        containerBg: colors.primary[100],
        headerBg: colors.primary[200],
        headerTextColor: colors.gray[800],
        subHeaderTextColor: colors.gray[400],
        borderBottomColor: colors.gray[125],
        noItemsTextColor: colors.primary[300],
        iconFill: colors.primary[300],
        cardItem: {
          amountTextColor: colors.gray[800],
          dateTextColor: colors.gray[800],
          boxShadowColor: colors.blackOpacity[10],
          serialTextColor: colors.gray[800],
          amountLoadTextColor: colors.gray[800],
          dateLoadTextColor: colors.primary.main,
          balanceTextColor: colors.gray[800],
          dividerColor: colors.gray[125],
          cardAccordion: {
            containerBg: colors.primary[200],
            balanceTextColor: colors.gray[350],
            balanceAmountColor: colors.black,
            dividerColor: colors.secondary[500],
            labelTextColor: colors.gray[350],
            valueTextColor: colors.gray[800]
          },
          cardAccordionBtn: {
            activeBg: colors.primary[200],
            activeIconFill: colors.white,
            iconFill: colors.primary.main
          }
        }
      }
    },

    orders: {
      headingColor: colors.gray[600],
      descriptionColor: colors.gray[400],
      ordersList: {
        containerBg: colors.primary[100],
        headerBg: colors.primary[200],
        headerTextColor: colors.gray[800],
        subHeaderTextColor: colors.gray[400],
        borderBottomColor: colors.gray[125],
        emptyMessageColor: colors.gray[225],
        item: {
          dateTextColor: colors.gray[800],
          checkoutIdTextColor: colors.gray[800],
          storeNameTextColor: colors.gray[800],
          storeNameTextMobileColor: colors.gray[500],
          itemsCountTextColor: colors.gray[800],
          itemsCountMobileTextColor: colors.gray[300],
          amountTextColor: colors.gray[800],
          iconColor: colors.gray[500],
          dividerColor: colors.gray[125]
        }
      },
      orderPage: {
        containerBg: colors.primary[100],
        borderColor: colors.primary.main,
        textColor: colors.gray[400],
        detailsList: {
          containerBg: colors.primary[100],
          headerBg: colors.primary[200],
          headerTextColor: colors.gray[400],
          borderBottomColor: 'transparent',
          emptyMessageColor: colors.gray[225],
          mobileDividerColor: colors.gray[300],
          detailsItem: {
            descriptionTextColor: colors.gray[800],
            priceTextColor: colors.gray[800],
            quantityTextColor: colors.gray[800],
            totalTextColor: colors.gray[800],
            itemBg: colors.primary[100],
            dividerColor: colors.gray[125],
            discountTextColor: colors.gray[300],
            discountAmountColor: colors.gray[300],
            promoTextColor: colors.gray[300],
            promoAmountColor: colors.gray[300],
            promoBg: colors.gray[115],
            promoIconColor: colors.gray[800]
          }
        }
      }
    },

    packages: {
      headingColor: colors.gray[600],
      packagesList: {
        containerBg: colors.primary[100],
        headerBg: colors.primary[200],
        headerTextColor: colors.gray[800],
        subHeaderTextColor: colors.gray[400],
        borderBottomColor: colors.gray[125],
        emptyMessageColor: colors.gray[225],
        packageItem: {
          nameTextColor: colors.secondary[800],
          unitsTextColor: colors.secondary[800],
          iconColor: colors.gray[800],
          dividerColor: colors.gray[125],
          expiresLabelColor: colors.gray[250],
          expiresTextColor: colors.secondary[800],
          amountLabelColor: colors.gray[250],
          amountTextColor: colors.secondary[800],
          buttonTextColor: colors.secondary[800],
          viewButtonTextColor: colors.secondary[800],
          receiptIconColor: colors.gray[400],
          mobileDividerColor: colors.gray[250]
        }
      },
      packagePage: {
        headingColor: colors.gray[600],
        packageBg: colors.secondary[500],
        packageTextColor: colors.white,
        subPackageList: {
          containerBg: colors.primary[100],
          headerBg: colors.primary[200],
          headerTextColor: colors.gray[800],
          emptyMessageColor: colors.gray[225],
          subPackageItem: {
            nameTextColor: colors.secondary[800],
            qtyLabelColor: colors.gray[250],
            qtyTextColor: colors.secondary[800],
            dividerColor: colors.secondary[500],
            usedLabelColor: colors.gray[250],
            usedTextColor: colors.secondary[800],
            remainingLabelColor: colors.gray[250],
            remainingTextColor: colors.secondary[800],
            mobileDividerColor: colors.gray[230]
          }
        }
      }
    },

    products: {
      headingColor: colors.gray[600],
      dividerColor: colors.primary.main,
      favoriteList: {
        containerBg: colors.primary[100],
        headerBg: colors.primary[200],
        headerTextColor: colors.gray[800],
        subHeaderTextColor: colors.gray[400],
        borderBottomColor: colors.gray[125],
        favoriteItem: {
          borderBottomColor: colors.gray[125],
          imageBg: 'transparent',
          emptyImageBg: colors.primary[200],
          noImageTextColor: colors.gray[300],
          heartIconColor: colors.primary.main,
          nameTextColor: colors.gray[550],
          brandTextColor: colors.gray[300],
          discountTextColor: colors.secondary[500],
          priceTextColor: colors.gray[550],
          memberSaveTextColor: colors.gray[375],
          chevronIconColor: colors.gray[800],
          isMemberPrice: colors.primary.main,
          iconColor: colors.primary[500]
        }
      },
      recentList: {
        containerBg: colors.primary[100],
        headerBg: colors.primary[200],
        headerTextColor: colors.gray[800],
        subHeaderTextColor: colors.gray[400],
        borderBottomColor: colors.gray[125],
        recentItem: {
          borderBottomColor: colors.gray[125],
          dateTextColor: colors.gray[550],
          providerTextColor: colors.gray[550],
          heartIconColor: colors.primary.main,
          nameTextColor: colors.gray[550],
          brandTextColor: colors.gray[300],
          priceTextColor: colors.gray[550],
          receiptIconColor: colors.gray[500],
          chevronIconColor: colors.gray[800],
          iconColor: colors.primary[500]
        }
      },
      browsePage: {
        headerBg: colors.secondary[500],
        selectControlTextColor: colors.gray[350],
        selectOptionTextColor: colors.gray[300],
        selectOptionBorderColor: colors.primary[200],
        selectOptionSvgColor: colors.secondary[500],
        dropdownIndicatorColor: colors.secondary[500],
        productsNumberTextColor: colors.white,
        productList: {
          containerBg: colors.primary[100],
          headerBg: colors.primary[200],
          headerTextColor: colors.secondary[800],
          productItem: {
            borderColor: colors.gray[125],
            imageBg: colors.primary[200],
            noImageTextColor: colors.gray[300],
            favoriteIconColor: colors.primary.main,
            productNameColor: colors.gray[550],
            brandNameColor: colors.gray[300],
            discountColor: colors.secondary[500],
            priceColor: colors.gray[550],
            memberSaveColor: colors.gray[375],
            addToCartButtonTextColor: colors.gray[600],
            addToCartButtonBg: colors.white,
            iconColor: colors.primary[500]
          }
        }
      },
      productPage: {
        borderColor: 'transparent',
        productBg: colors.gray[600],
        imageBg: colors.primary[200],
        noImageTextColor: colors.gray[300],
        productNameColor: colors.white,
        brandNameColor: colors.white,
        priceColor: colors.primary[300],
        favoriteIconColor: colors.primary.main,
        recentHistoryList: {
          containerBg: colors.primary[100],
          headerBg: colors.primary[200],
          headerTextColor: colors.gray[800],
          labelTextColor: colors.gray[400],
          borderBottomColor: colors.gray[125],
          recentHistoryItem: {
            textColor: colors.gray[550],
            borderBottomColor: colors.gray[125],
            iconColor: colors.gray[500]
          }
        }
      }
    },

    service: {
      headingColor: colors.gray[600],
      serviceTable: {
        containerBg: colors.primary[100],
        headerBg: colors.primary[200],
        headerTextColor: colors.gray[800],
        headerTextSecondaryColor: colors.gray[400],
        borderColor: colors.gray[125],
        textColor: colors.gray[550],
        iconColor: colors.gray[800],
        iconHoverColor: colors.gray[400]
      },
      serviceCards: {
        containerBg: colors.primary[100],
        headerBg: colors.primary[200],
        headerTextColor: colors.gray[800],
        borderTopColor: colors.secondary[100],
        itemBorderColor: colors.gray[250],
        labelColor: colors.gray[250],
        iconColor: colors.gray[800],
        iconHoverColor: colors.gray[800]
      },
      servicePage: {
        headerBg: colors.secondary[500],
        headerTextColor: colors.white,
        recentHistoryTable: {
          headerBg: colors.primary[200],
          headerTextColor: colors.gray[800],
          containerBg: colors.primary[100],
          borderColor: colors.gray[125],
          headerTextSecondaryColor: colors.gray[400],
          textColor: colors.gray[550]
        },
        recentHistoryCards: {
          headerBg: colors.primary[200],
          containerBg: colors.primary[100],
          borderColor: colors.gray[125],
          labelColor: colors.gray[250],
          textColor: colors.gray[550]
        },
        recommendationTable: {
          headerBg: colors.primary[200],
          headerTextColor: colors.gray[800],
          containerBg: colors.primary[100],
          borderColor: colors.gray[125],
          headerTextSecondaryColor: colors.secondary[800],
          textColor: colors.gray[550]
        }
      }
    }
  },

  components: {
    avatar: {
      badgeBgColor: colors.gray[600],
      badgeBorderColor: colors.primary.main,
      badgeTextColor: colors.primary.main
    },
    contentLoader: {
      redVariantColor: colors.red[300],
      defaultColor: colors.gray[225]
    },
    footer: {
      bgColor: colors.gray[600],
      textColor: colors.white,
      iconColor: colors.white,
      dividerColor: colors.gray[250]
    },
    headerColor: {
      topBg: colors.gray[800],
      bottomBg: colors.blue[800],
      bottomBorder: colors.gray[800],
      iconColor: colors.gray[200],
      logoColor: colors.white,
      primaryColor: colors.primary.main,
      linkColor: colors.white,
      dividerColor: colors.gray[100],
      badgeBg: colors.primary[200],
      badgeColor: colors.gray[600],
      tabletNavigation: {
        linkColor: colors.white,
        bgColor: colors.grayOpacity[90],
        buttonColor: colors.gray[225]
      }
    },
    cartBasket: {
      containerBg: colors.gray[100],
      itemBg: colors.white,
      textColor: colors.gray[800],
      borderColor: colors.gray[150],
      counterBorder: colors.secondary[200],
      defaultIconColor: colors.secondary[200],
      emptyImageBg: colors.primary[200],
      errorButtonBg: colors.red[200],
      qtyBg: colors.gray[100]
    },
    locations: {
      heading: colors.gray[550],
      subtitle: colors.gray[300],
      icon: colors.primary.main,
      divider: colors.primary.main,
      bg: 'transparent',
      tileBg: colors.primary[200],
      tileColor: colors.gray[800],
      headingColor: colors.white,
      headingBg: colors.primary.main,
      activeBg: colors.primary[200],
      favoriteIconColor: colors.gray[800],
      activefavoriteIconColor: colors.primary.main,
      itemBorder: colors.gray[125],
      locationName: colors.gray[800],
      phone: colors.gray[800],
      adress: colors.gray[800],
      mapIconColor: colors.secondary[500],
      distance: colors.gray[500],
      locationPage: {
        headingColor: colors.gray[550],
        descriptionColor: colors.gray[300]
      },
      infoBanner: {
        bg: colors.primary[200],
        title: colors.gray[800],
        subTitle: colors.gray[800],
        iconColor: colors.primary.main
      },
      dropdown: {
        bgColor: colors.primary[200],
        textColor: colors.gray[800],
        controlColor: colors.gray[800],
        controlBg: colors.white,
        indicatorColor: colors.gray[300]
      }
    },
    newCardForm: {
      bg: colors.primary[100],
      loaderBg: colors.blackOpacity[10],
      textColor: colors.gray[500],
      borderColor: colors.primary.main,
      secureMsg: colors.gray[275]
    },
    passwordRules: {
      checkIconColor: colors.secondary.main,
      emptyIconBorderColor: colors.black,
      textColor: colors.gray[800],
      reqBg: colors.primary[100]
    },
    paymentList: {
      cardBg: colors.primary[100],
      buttonBg: colors.white,
      buttonActiveBg: colors.gray[800],
      buttonActiveBorderColor: colors.gray[800],
      buttonActiveColor: colors.white,
      cardNumberColor: colors.gray[500],
      cardOwnerColor: colors.gray[800],
      cardExpColor: colors.gray[800],
      cardExpErrorColor: colors.red[600],
      overlayBg: colors.secondaryOpacity[90],
      overlayTextColor: colors.white,
      divider: colors.primary.main,
      itemDivider: colors.gray[125],
      label: colors.gray[500],
      cardProcessingLoader: {
        boxBg: colors.gray[100],
        heading: colors.gray[800],
        iconFill: colors.gray[800],
        spinnerColor: colors.gray[800],
        helperText: colors.gray[800]
      }
    },
    giftCardList: {
      cardBg: colors.primary[100],
      buttonBg: colors.white,
      buttonActiveBg: colors.gray[800],
      buttonActiveBorderColor: colors.gray[800],
      buttonActiveColor: colors.white,
      boxShadowColor: colors.blackOpacity[10],
      cardNumberColor: colors.gray[500],
      appliedBg: colors.red[700],
      appliedColor: colors.white,
      errorModal: {
        bg: colors.gray[100],
        title: colors.gray[800],
        iconColor: colors.red[500],
        serialColor: colors.gray[800],
        description: colors.gray[500]
      }
    },
    profileSidebar: {
      linkBg: colors.gray[100],
      linkColor: colors.gray[600],
      activeLinkColor: colors.gray[600],
      smallLinkActiveColor: colors.gray[600],
      linkActiveBg: colors.gray[115],
      linkIconColor: colors.gray[600],
      linkAccordionItemIconColor: colors.gray[600],
      smallLinkBg: colors.gray[100],
      smallLinkActiveBg: colors.secondary[175],
      accordionBg: colors.gray[100],
      accordionOpenBg: colors.gray[115],
      accordionOpenColor: colors.gray[600],
      avatarBorderColor: colors.primary.main,
      avatarHoverBg: colors.whiteOpacity[80],
      iconFill: colors.gray[800],
      iconText: colors.gray[800],
      nickameColor: colors.gray[600],
      memberSinceTextColor: colors.gray[300],
      dividerColor: colors.gray[600],
      calendarIconFill: colors.primary.main,
      mobileBg: colors.secondary.main,
      desktopBg: colors.gray[100],
      apptLabelColor: colors.gray[200],
      calendarTextColor: colors.gray[600],
      calendarDateTextColor: colors.gray[600],
      apptLabelBg: colors.secondary[100],
      calendarTextMobileColor: colors.white,
      calendarIconColor: colors.gray[600],
      calendarIconMobileColor: colors.white,
      signOutButtonColor: colors.gray[600],
      accountBalance: {
        titleBg: colors.red[600],
        titleColor: colors.white,
        amountBg: colors.red[100],
        amountColor: colors.gray[600]
      }
    },
    savingBlock: {
      bg: colors.primary[100],
      headerBg: colors.primary[200],
      headerTextColor: colors.gray[300],
      amountColor: colors.secondary[500]
    },
    giftCardBlock: {
      bg: colors.primary[100],
      textHeaderColor: colors.gray[300],
      textContentColor: colors.secondary[500]
    },
    seeMore: {
      bg: colors.primary[200],
      textColor: colors.gray[800]
    },
    progress: {
      background: colors.gray[600],
      locationNameColor: colors.white,
      changeButtonColor: colors.white,
      stepIconActiveColor: colors.primary.main,
      stepIconInactiveColor: colors.gray[250],
      stepIconCurrentColor: colors.white,
      stepSeparatorCompleteColor: colors.primary.main,
      stepSeparatorIncompleteColor: colors.gray[250],
      stepTextSeenColor: colors.white,
      stepTextUnseenColor: colors.gray[250]
    },
    paymentErrorModal: {
      overlayBackground: 'rgba(255, 255, 255, 0.9)',
      titleColor: colors.gray[550],
      descriptionColor: colors.gray[550]
    },
    simpleErrorModal: {
      overlayBackground: 'rgba(255, 255, 255, 0.9)',
      titleColor: colors.gray[550],
      descriptionColor: colors.gray[550]
    },
    continueShoppingModal: {
      overlayBackground: 'rgba(134, 101, 122, 0.9)',
      dividerColor: colors.primary.main,
      titleColor: colors.black,
      descriptionColor: colors.gray[800],
      backBtnColor: colors.gray[300]
    },
    guestCheckoutModal: {
      overlayBackground: 'rgba(134, 101, 122, 0.9)',
      closeButtonBackground: colors.gray[300],
      closeButtonColor: colors.black,
      bannerBorderColor: colors.gray[300],
      activeButtonBackground: colors.gray[300],
      borderColor: colors.secondary[500]
    },

    ui: {
      counter: {
        counterSvgColor: colors.gray[230],
        counterTextColorBase: colors.black,
        counterTextColorLgDefault: colors.secondary[500],
        counterTextColorLgAlt: colors.black
      },
      tabs: {
        tabBackground: colors.gray[100],
        tabSelectedAfterBg: colors.secondary[200],
        tabColor: colors.gray[800],
        bottomColor: 'transparent'
      },
      menu: {
        menuBackground: colors.gray[100],
        menuAvatarBorderColor: colors.secondary[400],
        menuLabelColor: colors.gray[800],
        menuIconColor: colors.gray[800],
        menuListBackground: colors.secondary[100],
        menuItemBackground: colors.secondary[100],
        menuItemActiveFontWeight: 600,
        menuDividerBorderColor: colors.gray[350]
      }
    }
  },

  theme: {
    generalStyles: {
      bodyTextColor: colors.gray[800],
      datePickerHeader: colors.primary[100],
      datePickerNavIcon: colors.primary.main,
      datePickerDayHoverBg: colors.primary[100],
      datePickerKeyboardSelectedBg: colors.primary[200],
      datePickerKeyboardSelectedHoverBg: colors.primary.main,
      datePickerSelectedDayBg: colors.primary[200],
      datePickerSelectedDayName: colors.gray[300],
      datePickerSelectedDayColor: colors.black,
      datePickerCurrentMonthColor: colors.gray[800],
      datePickerCurrentMonthBorderColor: colors.gray[150],
      datePickerNavArrowColor: colors.gray[800],
      datePickerDayColor: colors.gray[800],
      datePickerDayBg: 'transparent',
      datePickerSelectedDayBeforeBg: colors.primary.main,
      datePickerDayBeforeHoverBg: colors.primary[200],
      scrollColor: colors.gray[150]
    },
    button: {
      focusVisible: colors.primary[200],
      buttonSolidPrimaryColor: colors.gray[600],
      buttonSolidPrimaryBg: colors.primary.main,
      buttonSolidSecondaryColor: colors.white,
      buttonSolidSecondaryBg: colors.secondary[400],
      buttonSolidSecondaryLightColor: colors.gray[800],
      buttonSolidSecondaryLightBg: colors.secondary[100],
      buttonSolidTextColor: colors.gray[600],
      buttonSolidTextBg: 'transparent',
      buttonSolidRedColor: colors.white,
      buttonSolidRedBg: colors.red[700],
      buttonSolidBlackColor: colors.white,
      buttonSolidBlackBg: colors.black,
      buttonOutlinePrimaryBorderColor: colors.gray[400],
      buttonOutlinePrimaryColor: colors.gray[400],
      buttonOutlinePrimaryLightBorderColor: colors.primary.main,
      buttonOutlinePrimaryLightColor: colors.primary.main,
      buttonOutlineSecondaryBorderColor: colors.secondary[500],
      buttonOutlineSecondaryColor: colors.secondary[500],
      buttonOutlineSecondaryLightBorderColor: colors.white,
      buttonOutlineSecondaryLightColor: colors.white,
      buttonOutlineBlackBorder: colors.black,
      buttonOutlineBlackColor: colors.black,
      buttonBrandPrimaryBg: colors.secondary[500],
      buttonBrandPrimaryColor: colors.white,
      buttonBrandPrimarySvgFill: colors.white,
      buttonBrandPrimaryLightBg: colors.gray[100],
      buttonBrandPrimaryLightColor: colors.secondary[500],
      buttonBrandPrimaryLightSvgFill: colors.secondary[500],
      buttonBrandSecondaryBg: colors.white,
      buttonBrandSecondaryColor: colors.secondary[500],
      buttonBrandSecondarySvgFill: colors.secondary[500],
      buttonOutlineHoverPrimaryColor: colors.white,
      buttonOutlineHoverPrimaryBg: colors.gray[400],
      buttonOutlineHoverPrimaryLightBg: colors.primary.main,
      buttonOutlineHoverPrimaryLightColor: colors.white,
      buttonOutlineHoverSecondaryColor: colors.white,
      buttonOutlineHoverSecondaryBg: colors.secondary.main,
      buttonOutlineHoverSecondaryLightColor: colors.white,
      buttonOutlineHoverSecondaryLightBg: colors.secondary.main,
      buttonOutlineHoverBlackBg: colors.black,
      buttonOutlineHoverBlackColor: colors.white,
      buttonBrandHoverPrimaryBg: colors.secondary.main,
      buttonBrandHoverPrimaryColor: colors.white,
      buttonBrandHoverPrimarySvgFill: colors.white,
      buttonBrandHoverPrimaryLightBg: colors.secondary.main,
      buttonBrandHoverPrimaryLightColor: colors.white,
      buttonBrandHoverPrimaryLightSvgFill: colors.white,
      buttonBrandHoverSecondaryBg: colors.secondary[500],
      buttonBrandHoverSecondaryColor: colors.white,
      buttonBrandHoverSecondarySvgFill: colors.white,
      buttonTextColor: colors.gray[800]
    },
    checkbox: {
      checkboxPrimaryBorderColor: colors.gray[300],
      checkboxPrimaryCheckedBg: colors.primary.main,
      checkboxPrimaryCheckedBorderColor: colors.primary.main,
      checkboxPrimaryHoverBg: colors.primary.main,
      checkboxPrimaryHoverBorderColor: colors.primary.main,
      checkboxSecondaryBorderColor: colors.gray[300],
      checkboxSecondaryCheckedBg: colors.secondary.main,
      checkboxSecondaryCheckedBorderColor: colors.secondary.main,
      checkboxSecondaryHoverBg: colors.secondary.main,
      checkboxSecondaryHoverBorderColor: colors.secondary.main,
      checkboxGrayBorderColor: colors.gray[375],
      checkboxGrayCheckedBg: colors.gray[800],
      checkboxGrayCheckedBorderColor: colors.gray[800],
      checkboxGrayHoverBg: colors.gray[800],
      checkboxGrayHoverBorderColor: colors.gray[800],
      checkboxInvalidBorderColor: colors.red[900],
      checkboxOutlineColor: colors.gray[300]
    },
    input: {
      inputBrandFieldColor: colors.gray[800],
      inputBrandFieldBorderColor: 'transparent',
      inputBrandFieldBg: colors.white,
      inputBrandFieldHoverBorderColor: 'transparent',
      inputBrandFieldPlaceholderColor: colors.gray[600],
      inputBrandFieldFocusBorderColor: 'transparent',
      inputBrandFieldInvalidBorderColor: colors.red[500],
      inputBrandFieldInvalidBg: colors.redOpacity[5],
      inputAuthFieldBg: colors.primary[100],
      inputAuthFieldPlaceholderColor: colors.gray[600],
      inputAuthFieldInvalidBg: colors.redOpacity[5]
    },
    radio: {
      radioControlBorderColor: colors.gray[600],
      radioControlCheckedBg: colors.primary.main,
      radioControlCheckedBorderColor: colors.primary.main,
      radioControlCheckedBeforeBg: colors.secondary.main,
      radioControlHoverBg: colors.primary.main,
      radioControlHoverBorderColor: colors.primary.main
    },
    stepper: {
      stepperStepActiveBg: colors.primary.main,
      stepperTitleColor: colors.gray[600],
      stepperTitleActiveColor: colors.white,
      stepperPrimaryStepBg: colors.gray[50],
      stepperPrimaryStepActiveBg: colors.primary.main,
      stepperPrimaryTitleActiveColor: colors.white,
      stepperSecondaryStepBg: colors.gray[100],
      stepperSecondaryStepActiveBg: colors.secondary[500],
      stepperSecondaryTitleColor: colors.gray[800],
      stepperSecondaryTitleActiveColor: colors.white
    },
    tabs: {
      tabsRootBg: colors.gray[100]
    }
  }
};

export default palette;
